import React from 'react';

import { SlideTileGenerationStatus } from 'interfaces/tileGeneration';
import { useSlidesTileGenerationStatus } from 'utils/queryHooks/useSlidesTileGenerationStatus';
import { useCurrentLabId } from 'utils/useCurrentLab';

const NO_STATUSES: Record<string, SlideTileGenerationStatus> = {};

const TileGenerationStatusContext = React.createContext<Record<string, SlideTileGenerationStatus>>(NO_STATUSES);

/** Fetches the latest tile generation job of every listed slide in one request, for the cards rendered inside. */
export const StudyTileGenerationStatusProvider: React.FC<
  React.PropsWithChildren<{ studyId?: string; slideIds: string[] }>
> = ({ studyId, slideIds, children }) => {
  const { labId } = useCurrentLabId();
  const { data } = useSlidesTileGenerationStatus({ labId, studyId, slideIds });
  return (
    <TileGenerationStatusContext.Provider value={data ?? NO_STATUSES}>{children}</TileGenerationStatusContext.Provider>
  );
};

export const useSlideTileGenerationStatus = (slideId?: string) => {
  const statusesBySlideId = React.useContext(TileGenerationStatusContext);
  return slideId ? statusesBySlideId[slideId] : undefined;
};
